<div class="absolute inset-0 flex items-center justify-center p-4" role="dialog" aria-modal="true"
    aria-labelledby="create-group-title">
    <button type="button" class="absolute inset-0 bg-zinc-200/40 backdrop-blur-md dark:bg-zinc-900/60"
        (click)="closeCreateGroup()" aria-label="Dismiss create group"></button>

    <section class="relative z-10 flex max-h-full w-full max-w-lg flex-col overflow-hidden rounded-2xl primary-card-container">
        <div class="flex shrink-0 items-start justify-between gap-3 border-b border-border px-4 py-3">
            <div class="min-w-0">
                <h2 id="create-group-title" class="text-base font-semibold text-primary">Create a Group</h2>
                <p class="mt-1 text-sm text-secondary">You'll add creators after you save.</p>
            </div>
            <button type="button" (click)="closeCreateGroup()"
                class="rounded-full bg-zinc-200 p-1.5 text-primary hover:bg-zinc-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600 dark:bg-zinc-600 dark:hover:bg-zinc-500"
                aria-label="Close create group">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        @if (!groupCreated()) {
        <div class="min-h-0 flex-1 space-y-5 overflow-y-auto px-4 py-4">
            <div>
                <label for="project-name" class="block text-xs font-medium text-primary">Group name</label>
                <input type="text" id="project-name" [formField]="recruitGroupForm.groupName"
                    class="mt-1 block w-full rounded-md bg-white px-3 py-1.5 text-sm text-primary outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-zinc-900 dark:outline-zinc-700 dark:placeholder:text-zinc-500">
            </div>

            <div>
                <label for="project-description" class="block text-xs font-medium text-primary">Description
                    <span class="font-normal text-secondary">(optional)</span></label>
                <textarea rows="3" id="project-description" [formField]="recruitGroupForm.groupDescription"
                    class="mt-1 block w-full rounded-md bg-white px-3 py-1.5 text-sm text-primary ring-1 ring-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary dark:bg-zinc-900 dark:ring-zinc-700 dark:placeholder:text-zinc-500"></textarea>
            </div>

            <fieldset class="space-y-3">
                <legend class="text-xs font-medium text-primary">Who can see this?</legend>
                <div class="relative flex items-start">
                    <div class="absolute flex h-6 items-center">
                        <input id="privacy-public" value="user" [formField]="recruitGroupForm.privacy"
                            aria-describedby="privacy-public-description" type="radio"
                            class="relative size-4 appearance-none rounded-full border border-gray-300 before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary checked:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 dark:border-zinc-700 dark:before:bg-zinc-900 dark:checked:border-primary dark:checked:bg-primary">
                    </div>
                    <div class="pl-7 text-xs">
                        <label for="privacy-public" class="font-medium text-primary">Just me</label>
                        <p id="privacy-public-description" class="text-secondary">Only you will see this group.</p>
                    </div>
                </div>
                <div class="relative flex items-start">
                    <div class="absolute flex h-6 items-center">
                        <input id="privacy-private-to-project" value="brand" [formField]="recruitGroupForm.privacy"
                            aria-describedby="privacy-private-to-project-description" type="radio"
                            class="relative size-4 appearance-none rounded-full border border-gray-300 before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary checked:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 dark:border-zinc-700 dark:before:bg-zinc-900 dark:checked:border-primary dark:checked:bg-primary">
                    </div>
                    <div class="pl-7 text-xs">
                        <label for="privacy-private-to-project" class="font-medium text-primary">Share with my team</label>
                        <p id="privacy-private-to-project-description" class="text-secondary">Only members of this brand
                            will be able to access this group.</p>
                    </div>
                </div>
            </fieldset>
        </div>
        } @else {
        <div class="flex flex-col items-center px-4 py-10 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-12 text-green-500 dark:text-green-400" aria-hidden="true">
                <path d="M20 6 9 17l-5-5" />
            </svg>
            <h3 class="mt-3 text-sm font-semibold text-primary">Group created</h3>
            <p class="mt-1 text-sm text-secondary">You can add creators from any profile after you save.</p>
        </div>
        }

        <div class="flex shrink-0 items-center gap-3 border-t border-border px-4 py-3"
            [class.justify-between]="!groupCreated()" [class.justify-end]="groupCreated()">
            @if (!groupCreated()) {
            <button (click)="closeCreateGroup()" type="button" class="secondary-button text-primary">
                Cancel
            </button>
            }

            @if (submitInProgress()) {
            <span class="inline-flex items-center gap-x-1.5 text-xs font-medium text-secondary">
                <svg aria-hidden="true" class="size-5 animate-spin text-gray-200 fill-primary dark:text-gray-300"
                    viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor" />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill" />
                </svg>
                Creating group...
            </span>
            } @else if (groupCreated()) {
            <button (click)="closeCreateGroup()" type="button" class="primary-button">
                Done
            </button>
            } @else {
            <button (click)="createGroup()" type="button" [disabled]="recruitGroupForm().invalid()"
                class="primary-button inline-flex items-center gap-x-2 disabled:cursor-not-allowed disabled:opacity-60">
                Save Group
            </button>
            }
        </div>
    </section>
</div>
